import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "inquiry end"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "bt_group bt_home" };
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
const PAID_USER = 'paid_user';
const FREE_USER = 'free_user';
export default /*@__PURE__*/ _defineComponent({
    __name: 'profile_complete',
    props: {
        common: {},
        user_type: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[8] || (_cache[8] = _createElementVNode("h2", null, "基本情報登録完了", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("p", null, [
                                    (props.user_type === PAID_USER)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "会員"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_6, "無料会員として")),
                                    _cache[0] || (_cache[0] = _createTextVNode(" 登録が完了しました。ありがとうございます。")),
                                    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                                    _cache[2] || (_cache[2] = _createTextVNode(" 貴社のビジネス課題解決に向けて、尽力してまいります。")),
                                    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                    _cache[4] || (_cache[4] = _createTextVNode(" 今後とも何卒宜しくお願い申し上げます。")),
                                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(_unref(Link), {
                                    href: _ctx.route('question.index'),
                                    class: "bt_home"
                                }, {
                                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                                        _createTextVNode("ホームに戻る")
                                    ])),
                                    _: 1,
                                    __: [6]
                                }, 8, ["href"]),
                                (props.user_type === FREE_USER)
                                    ? (_openBlock(), _createBlock(_unref(Link), {
                                        key: 0,
                                        href: _ctx.route('plan.show'),
                                        class: "bt_home"
                                    }, {
                                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                                            _createTextVNode("料金プラン変更")
                                        ])),
                                        _: 1,
                                        __: [7]
                                    }, 8, ["href"]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
